import { theme } from "styles";
import { INpsCocoImageData, INpsTypes } from "./nps-coco-image.types";
export const NpsCocoImageData: Record<INpsTypes, INpsCocoImageData> = {
  neutralData: {
    imageSrc: "/assets/nps/coco-yellow.svg",
    text: "Mau kasih rekomendasi",
    color: theme.colors.yellow["600"]
  },
  promoterData: {
    imageSrc: "/assets/nps/coco-green.svg",
    text: "Pastinya!",
    color: theme.colors.green["800"]
  },
  initialData: {
    imageSrc: "/assets/nps/coco-blue.svg",
    text: "Pilih skornya, ya",
    color: theme.colors.neutral["1000"]
  },
  semiNegative: {
    imageSrc: "/assets/nps/coco-red.svg",
    text: "Masih ragu",
    color: theme.colors.tango[600]
  },
  negativeData: {
    imageSrc: "/assets/nps/coco-red.svg",
    text: "Nggak mau",
    color: theme.colors.tango[600]
  }
};
